<template>
<div class="testdrive-wrap" ref="testContainer">
  <div class="testdrive">
    <Header></Header>
    <div class="test-info">
      <NewsTemplate :listData="testList"></NewsTemplate>
    </div>
    <Footer class="app-footer"></Footer>
  </div>

</div>
</template>

<script>
import NewsTemplate from '@/components/NewsTemplate/NewsTemplate';
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';
import BScroll from 'better-scroll';
export default {
  name: 'MeasurementTestDrive',
  components: {
    NewsTemplate,
    Header,
    Footer
  },
  data() {
    return {
      testList: [],
      pageSize: 8,
      page: 1
    }
  },
  created() {
    this.getNewsList();
    setTimeout(() => {
      this.$nextTick(() => {
        this.initScroll()
      })
    }, 500)
  },
  mounted() {

  },
  methods: {
    async getNewsList(page) {
      const result = await this.$http.newsAndInformation.getNewsList({
        classify: 3,
        page:page
      });
      if (result.code === 200) {
        this.testList.push(...result.data);
      } else {
        
        return
      }
    },
    initScroll() {
      this.scroll = new BScroll(this.$refs.testContainer, {
        scrollY: true,
        click: true,
        probeType: 3,
        pullUpLoad: {
          threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
          stop: 20
        },
      })
      this.scroll.on('pullingUp', async (params) => {
        const {
          page,
          pageSize
        } = this
        this.page = page + 1;
        await this.getNewsList(this.page)
        this.$nextTick(() => {
          this.scroll.refresh()
          this.scroll.finishPullUp()
        })
      })
    },
  }
}
</script>

<style lang="less">
.testdrive-wrap {
  height: 100vh;
  overflow: hidden;
  .test-info {
    padding: 0 20px;
  }
}
</style>
